<section>

  <div class="instruction-text">
    Map Items to Onelynk Items
  </div>

  <div class="p-grid">
    <app-data-table [columns]="tableColumns" [value]="itemMappings" sortField="quickBooksUser" [leftCaptionTemplate]="leftTemplate">
      <ng-template #codeTypeTemplate let-row="row" let-rowIndex="rowIndex" >
        <p-dropdown name="codeType-{{rowIndex}}" [placeholder]="Validation.DropdownPlaceholder"
                    [options]="codeTypeDropDown"
                    [style]="{'overflow':'visible', 'max-width':'none'}"
                    [showClear]="true" [filter]="true"
                    (onChange)="onChangeItemOrCodeType(row)"
                    [(ngModel)]="row.codeType"></p-dropdown>
      </ng-template>
      <ng-template #itemTypeTemplate let-row="row" let-rowIndex="rowIndex" >
        <p-dropdown name="itemType-{{rowIndex}}" [placeholder]="Validation.DropdownPlaceholder"
                    [options]="itemTypeDropDown"
                    [style]="{'overflow':'visible', 'max-width':'none'}"
                    [showClear]="true" [filter]="true"
                    (onChange)="onChangeItemOrCodeType(row)"
                    [(ngModel)]="row.itemType" ></p-dropdown>
      </ng-template>

      <ng-template #ledgerAccountTemplate let-row="row" let-rowIndex="rowIndex" >
        <div *ngFor="let map of row?.accountMappings">
          {{ map?.accountMappingType | titleCase}}
          <p-dropdown  name="ledgerAccount-{{map?.accountMappingType}}-{{rowIndex}}" [placeholder]="Validation.DropdownPlaceholder"
                      [options]="this.dropDownMap?.get(map?.accountMappingType)"
                      [style]="{'overflow':'visible', 'max-width':'none'}"
                      [showClear]="true" [filter]="true"
                      [(ngModel)]="map.ledgerAccountId">
          </p-dropdown>
        </div>


      </ng-template>
      <ng-template #leftTemplate>
        <button pButton type="button" class="icon-action" icon="fa fa-download" pTooltip="Add Items to Catalog" tooltipPosition="top"
                (click)="onClickAddItems()">
        </button>
      </ng-template>
    </app-data-table>
  </div>

  <div class="p-grid">
    <div class="p-col-12 p-md-12 p-lg-12" style="text-align:right;margin-top:10px;">
      <button pButton class="button-inaction" icon="fa fa-refresh" type="button" label="Import Items" (click)="importItemMappings()">
      </button>
      <button pButton type="button" class="button-action" icon="fa fa-check" label="Save"
              (click)="onClickSaveMappings()">
      </button>
    </div>
  </div>

</section>
